import { connect } from 'react-redux'
import { compose, withHandlers, withState } from 'recompose'

import { api } from 'modules/org/api'
import * as UserSelectors from 'modules/user/selectors'

import VerifyEmail from './component'

const mapStateToProps = (state) => ({
  password: UserSelectors.getPassword(state),
  email: UserSelectors.getEmail(state) || '',
  name: UserSelectors.getName(state),
})

export default compose(
  connect(mapStateToProps, null),
  withState('loading', 'setLoading', false),
  withState('showError', 'setShowError', false),
  withState('showSuccessNotification', 'setShowSuccessNotification', false),
  withHandlers({
    onResendEmail: (props) => () => {
      props.setLoading(true)
      props.setShowError(false)
      props.setShowSuccessNotification(false)
      api
        .resendVerificationEmail({ email: props.email })
        .then(() => props.setLoading(false))
        .then(() => props.setShowSuccessNotification(true))
        .catch((err) => {
          console.error(err)
          props.setShowError(true)
          props.setLoading(false)
        })
    },
  })
)(VerifyEmail)
